import { z } from 'zod'

import { ObservationFrequencySchema } from '@/pages/instruments/new-instrument/schemas/autocall-standard.schema'
import { autocallBarrierStepSchema } from '@/pages/instruments/new-instrument/schemas/shared/autocall-barrier-step.schema'
import { baseStructuredSchema } from '@/pages/instruments/new-instrument/schemas/shared/base-structured.schema'
import { knockdownInputLevelSchema } from '@/pages/instruments/new-instrument/schemas/shared/knockdown-input-level.schema'

export const autocallConsolationSchema = baseStructuredSchema.extend({
  instrument_type: z.literal('autocall-consolation'),

  autocall_yearly_observations: ObservationFrequencySchema,
  coupon_rate_annual: z.number(),
  autocall_barrier_level: z.number(),
  payoff_barrier_level: z.number(),

  knockdown_input_level: knockdownInputLevelSchema,
  autocall_barrier_step: autocallBarrierStepSchema,
})

export type AutocallConsolationSchemaType = z.infer<typeof autocallConsolationSchema>
